import {
  MY_LEARNING_URL_PATH,
  COURSE_URL_PATH,
  LESSON_URL_PATH,
  LEARNING_PATH_URL_PATH,
  CATALOG_URL_PATH,
} from './getUrl';

export const detectPage = (currentPage: string): string => {
  const pages = currentPage.split('/');

  if (pages.includes(COURSE_URL_PATH) && !pages.includes(LESSON_URL_PATH)) {
    return 'courseScreen';
  }

  if (pages.includes(LEARNING_PATH_URL_PATH)) {
    return 'learningPathScreen';
  }

  if (pages.includes(COURSE_URL_PATH) && pages.includes(LESSON_URL_PATH)) {
    return 'lessonScreen';
  }

  if (pages.includes(CATALOG_URL_PATH)) {
    return 'catalogScreen';
  }

  if (pages.includes(MY_LEARNING_URL_PATH)) {
    return 'myLearningScreen';
  }

  if (pages.includes('profile')) {
    return 'profileScreen';
  }

  return 'homeScreen';
};
